// 不需要
import React, { Component } from 'react'
import './index.css';

class Home extends Component {
    render() {
        return (
            <div className="welcome">
                  欢迎使用彩生活物业信息化管理平台
            </div> 
        );
    }
}

export default Home;


// WEBPACK FOOTER //
// ./src/page/App/Home.js